import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { hexToRgba } from 'builder/styles/colors'
import Typography, { FontWeights } from 'builder/styles/typography'

type ButtonContainerRightProps = {
  $isInvisible?: boolean
  $invisibilityStrategy?: 'invisible' | 'none'
}

const { White, Neutral100 } = Colors

export const Topbar = styled.div<{ previewWidth?: number }>`
  position: absolute;
  left: 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: -60px;
  ${({ previewWidth }) =>
    typeof previewWidth === 'number' &&
    previewWidth < 450 &&
    css`
      left: 50%;
      margin-left: -225px;
      width: 450px;
    `};
`

export const ButtonContainerRight = styled.div<ButtonContainerRightProps>(props => {
  const { $isInvisible, $invisibilityStrategy } = props
  return css`
    display: flex;
    flex-direction: row;
    align-items: center;

    ${$isInvisible &&
    ($invisibilityStrategy === 'invisible'
      ? css`
          visibility: hidden;
          opacity: 0;
          pointer-events: none;
        `
      : css`
          display: none;
        `)}
  `
})

export const SelectTemplateButtonContainer = styled.div`
  position: relative;
`

export const SelectTemplateButton = styled.span<{ isLightBackground?: boolean }>`
  padding: 0 12px 0 6px;
  height: 38px;
  border-radius: ${({ isLightBackground }) => (isLightBackground ? '4px' : '19px')};
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${hexToRgba(White)};
  cursor: pointer;
  background-color: ${({ isLightBackground }) =>
    isLightBackground ? Colors.Blue20 : hexToRgba(Neutral100, 0)};
  color: ${({ isLightBackground }) => (isLightBackground ? Colors.Blue50 : hexToRgba(White))};

  ${({ isLightBackground }) =>
    isLightBackground &&
    css`
      ${FontWeights.Medium};
    `}

  transition: background-color 0.1s ease;

  &:hover {
    background-color: ${hexToRgba(Neutral100, 0.15)};
  }
`

export const SelectTemplateIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
`

export const SelectTemplateText = styled.p`
  ${Typography.Caption};
`
